export default __webpack_public_path__ + "static/media/logo-with-text.ff5795e1.svg";